var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"stk-meeting-assistant-logo"},[_c('img',{attrs:{"src":`${_vm.$root.$data.STATIC_ROOT}images/products/meeting-assistant-on-dark.png`,"width":"262","height":"38"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }